<template>
  <a-modal v-model="show" width="60%" height="70%" destroyOnClose :footer="null" :title="'室内轨迹'" :maskClosable="false" :afterClose="onClose">
    <div class="area-map" id="indoorMap"></div>

    <a-slider
      :min="0"
      :max="100"
      v-model="percent"
      :tipFormatter="tipFormatter"
      @change="onChange"
    />
    <div class="control">
      <a-button-group>
        <a-button @click="start" icon="caret-right">

        </a-button>
        <a-button @click="pause">
          <zx-icon type="icon-tingzhi"></zx-icon>
        </a-button>

      </a-button-group>
    </div>
  </a-modal>
</template>

<script>
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.pm";
import "leaflet.pm/dist/leaflet.pm.css";
import iconNormalImg from '@assets/images/marker_normal_icon.png'
import MovingMarker from "@/utils/movingMarker";

export default {
  name: 'IndoorTrack',
  props:{
    scene: {
      type: Object
    },
    points:{
      type: Array
    },
    personInfo: {
      required: true
    }
  },
  data() {
    return {
      percent: 0,
      show: false,
      inMap: null,
      intervalFlag: null,
      movingMarker: null,
      index: 1,
      layerGroup: null,
      duration: 500
    }
  },
  beforeDestroy () {
    if(this.intervalFlag) {
      clearInterval(this.intervalFlag)
      this.intervalFlag = null
    }
  },
  methods: {
    onChange(value){
      // console.log('onChange:' + value)
      if(this.intervalFlag) {
        clearInterval(this.intervalFlag)
        this.intervalFlag = null
      }
      this.layerGroup.clearLayers()
      this.index = Math.round(this.points.length * value / 100)
      if(this.index === 0) {
        this.index = 1
      }
      this.quickDraw()
    },
    quickDraw(){
      for(let i = 1 ; i < this.index; i ++) {
        //this.movingMarker.moveTo([this.points[i].y, this.points[i].x], 1)
        let polyline = L.polyline(
            [[this.points[i-1].y, this.points[i-1].x],[this.points[i].y, this.points[i].x]],
            { color: "red" }
        )
        this.layerGroup.addLayer(polyline)
      }
      this.movingMarker.moveTo([this.points[this.index - 1].y, this.points[this.index - 1].x], 1)
      // console.log('quickDraw end')
      this.$nextTick(() => {
        this.move()
      })
    },
    tipFormatter (num) {
      return `${num}%`
    },
    start() {
      this.move()
    },
    pause(){
      if(this.intervalFlag) {
        clearInterval(this.intervalFlag)
        this.intervalFlag = null
      }
    },
    onClose(){
      if(this.intervalFlag) {
        clearInterval(this.intervalFlag)
        this.intervalFlag = null
      }
      this.$emit('end')
    },
    closeIndoorMap() {
      this.show = false
    },
    showIndoorMap(){
      this.index = 1
      this.show = true
      this.showTileLayer()
    },
    bdToArr(va){
      if(va) {
        let sp = va.split(",")
        let arr = []
        sp.forEach(item => {
          let latLng = item.split("_")
          if(latLng.length == 2)
            arr.push(latLng)
        })
        return arr
      }
    },
    // 绘制 leaflet
    showTileLayer() {
      this.$nextTick(() => {
        if (this.inMap) {
          // 销毁地图
          this.inMap.remove();
        }

        let map = L.map("indoorMap", {
          minZoom: 1,
          maxZoom: 8,
          zoom: 6,
          crs: L.CRS.Simple,
          doubleClickZoom: false, // 禁用双击放大
          attributionControl: false, // 移除右下角leaflet标识
          zoomSnap: 0.1, //缩放倍数
          zoomControl: false,
        });
        this.inMap = map;
        let bounds = this.bdToArr(this.scene.bounds)
        L.imageOverlay('https://zxsmart.cn' + this.scene.map,bounds).addTo(this.inMap);
        map.fitBounds(bounds)
        //添加比例尺
        L.control.scale({ position: "bottomright", imperial: false }).addTo(this.inMap);

        this.createMarker()
      })
    },
    createMarker(){
      this.layerGroup = L.layerGroup()
      this.layerGroup.addTo(this.inMap);

      let content = `<div style="position:relative;" >
        <div style="position:absolute;
              font-size:12px;
              white-space:nowrap;
              max-height:100%;
              width:100%;
              display:flex;
              justify-content: center;
              align-items: center;
              top:-18px;
              left:-0px;
              color:#000;
              ">${this.personInfo.entity || ""}</div>
        <img src=${iconNormalImg} style="width: 25px; height: 25px;">
        </div>`;

      let myIcon = L.divIcon({
        html: content, //marker标注
        className: 123,
        iconSize: [25, 25], //marker宽高
        iconAnchor: [12.5, 25], //文字标注相对位置
      });

      this.movingMarker = L.Marker.movingMarker([[this.points[0].y,this.points[0].x],[this.points[0].y,this.points[0].x]], 100, { autostart: true, loop: false, icon: myIcon });
      this.movingMarker.addTo(this.inMap)

      if(this.points.length > 1){
        this.move()
      }else{
        setTimeout(() => {
          this.closeIndoorMap()
        })
      }
    },
    move(){
      this.intervalFlag = setInterval(() => {
        if(this.points.length > this.index){
          this.movingMarker.moveTo([this.points[this.index].y, this.points[this.index].x], this.duration)
          let polyline = L.polyline(
              [[this.points[this.index-1].y, this.points[this.index-1].x],[this.points[this.index].y, this.points[this.index].x]],
              { color: "red" }
          )
          //polyline.addTo(this.inMap)
          //this.trackLine.push(polyline)
          this.layerGroup.addLayer(polyline)
          this.percent = (this.index + 1) * 100 / this.points.length
          this.index ++
        }else{
          clearInterval(this.intervalFlag)
          this.intervalFlag = null
          this.closeIndoorMap()
        }
      },this.duration * 1.2)
    }
  }
}
</script>

<style lang="less" scoped>
.area-map-border{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 999;
  padding: 3px;
  border-radius: 10px;
  // background: #FFE6B0;
  width: 75%;
  height: 80vh;
}

.area-map{
  width: 100%;
  height: 600px;
  // background: rgba(209, 213, 209, 0.99);
  border-radius: 10px;
}
</style>
